import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Button, Col, Modal, notification, Popconfirm, Row } from "antd";
import { useCallback, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import FormDefinePilote, {
  formName,
} from "../../components/forms/FormDefinePilote/FormDefinePilote";
import useSubmit from "../../components/forms/FormDefinePilote/useSubmit";
import FormEventValidate, {
  formNameEventValidate,
} from "../../components/forms/FormEventValidate/FormEventValidate";
import useSubmitValidate from "../../components/forms/FormEventValidate/useSubmitValidate";
import Breadcrumbs from "../../components/layout/BreadCrumbs";
import PageLayout from "../../components/layout/PageLayout/PageLayout";
import TableActions from "../../components/tables/TableActions/TableActions";
import Br from "../../components/ui/Br";
import spacing from "../../components/ui/spacingConfig";
import {
  useFetchEventQuery,
  useFetchThemesQuery,
  useFetchUsersForFieldQuery,
} from "../../features/api/apiSlice";
import { useCrudAction } from "../../features/api/crud/hooks/useCrudAction";
import { useCrudEvent } from "../../features/api/crud/hooks/useCrudEvent";
import { amITheEventPilote } from "../../features/events/eventHelpers";
import { modalProps } from "../../features/modals/modalProps";
import { useModal } from "../../features/modals/useModal";
import { useAppSelector } from "../../features/redux-store/hooks";
import { useRole } from "../../features/roles/useRole";
import styles from "./PageEvent.module.scss";
import CardCauseAnalysis from "./components/CardCauseAnalysis";
import CardDateAndPlace from "./components/CardDatePlace";
import CardDescription from "./components/CardDescription";
import CardPiloteGravity from "./components/CardPiloteGravity";

const PageEvent: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { isPilote, isAdmin, isUser } = useRole();
  const { user } = useAppSelector((state) => state.auth);

  /**
   * Fetch event
   */
  const {
    data: eventData,
    isFetching,
    refetch: refetchEvent,
    error,
  } = useFetchEventQuery(Number(id), {
    skip: !id,
  });

  /**
   * Handle 404 and 400's errors
   */
  useEffect(() => {
    const _error = error as { status?: number } | undefined;

    const notFound = _error?.status && _error?.status === 404;
    const basStatus = _error?.status && _error?.status >= 400;

    if (notFound) {
      notification.error({
        message:
          "Aucun Ã©vÃ©nement trouvÃ©. Veuillez vÃ©rifier vos droits avec l'administrateur.",
      });
      navigate("/events");
    } else if (basStatus) {
      notification.error({
        message:
          "Une erreur est survenue lors de la rÃ©cupÃ©ration de l'Ã©vÃ©nement.",
      });
      navigate("/events");
    }
  }, [error, navigate]);

  /**
   * Fetch "pilotes" and "themes"
   */
  const { data: pilotes, isFetching: isFetchingUsers } =
    useFetchUsersForFieldQuery("pilote");
  const { data: admins, isFetching: isFetchingUsersAdmins } =
    useFetchUsersForFieldQuery("sdlp-superadmin");
  const { data: themesData, isFetching: isFetchingThemes } =
    useFetchThemesQuery();

  /**
   * Shortcuts
   */
  const dataReadyForModal = !isFetchingUsers && !isFetchingThemes && !isFetchingUsersAdmins;

  console.log(user)
  console.log(eventData)
  let pilote = pilotes?.find((user) => user.id === eventData?.pilotes[0]?.id);
  // cas ou le pilote est directement un admin
  if (typeof pilote === 'undefined') {pilote = admins?.find((user) => user.id === eventData?.pilotes[0]?.id);}
  console.log(pilote)

  const hasPilote = Boolean(pilote);

  /**
   * Dispatch Pilote modal & request
   */
  const {
    onShowModal: showDefPiloteModal,
    isModalOpen: isDefPiloteModalOpen,
    onHideModal: onHideModalDefinePilote,
  } = useModal();

  const { dispatchPilote, isLoading: isDispatchingPilote } = useSubmit({
    eventId: Number(id),
    hideModal: onHideModalDefinePilote,
    refetchEvent,
  });

  /**
   * - Archive request
   * - Ask validation
   */
  const {
    onAskValidation,
    isAskingValidation,
    archiveEvent,
    isArchiving,
    onReopen,
    isReopening,
  } = useCrudEvent({
    navigate,
    fetchEvent: refetchEvent,
  });

  /**
   * Dispatch Pilote modal & request
   */
  const {
    onShowModal: showCloseOrRefuseModal,
    isModalOpen: isCloseOrRefuseModalOpen,
    onHideModal: onHideModalCloseOrRefuse,
  } = useModal();

  /**
   * Validate or refuse event
   */
  const { onSubmit: validateOrRefuseOnSubmit, isLoading: isValidating } =
    useSubmitValidate({
      id: Number(id),
      onSuccess: () => {
        onHideModalCloseOrRefuse();
        refetchEvent();
      },
    });

  /**
   * Navigation handlers
   */
  const navigateToEdit = useCallback(() => {
    navigate(`/events/${id}/edit`);
  }, [id, navigate]);

  const navigateToActionNew = useCallback(() => {
    navigate(`/events/${id}/actions/new`);
  }, [id, navigate]);

  /**
   * Delete action
   */
  const { onDelete: onDeleteAction, isDeleting: isDeletingAction } =
    useCrudAction(undefined, refetchEvent, Number(id));

  /**
   * Loading
   */
  const isPageLoading =
    isFetching ||
    isValidating ||
    isArchiving ||
    isAskingValidation ||
    isReopening;

  const hasCauseAnalysis = Boolean(eventData?.causeAnalysis?.length);
  const canCreateAction = true;

  const iAmTheAssignedPilote = amITheEventPilote(eventData, user?.profile.sub);



  return (
    <PageLayout pageContainerClassName={styles.root} isLoading={isPageLoading}>
      {/**
       * Top (breadcrumbs, and action buttons)
       */}
      {!isPageLoading && ( // Show only when not loading = resolves Popconfirm  "not disappearing" issue after submiting the requests
        <Row justify="space-between" align="middle">
          {!isFetching && (
            <Col>
              <Breadcrumbs
                pageName="event"
                eventName={eventData?.name}
                eventId={eventData?.id}
              />
            </Col>
          )}
          <Col>
            <Row gutter={spacing.m} className={styles.buttonsContainer}>
              {isAdmin && (
                <Col>
                  <Button type="primary" onClick={navigateToEdit}>
                    Modifier
                  </Button>
                </Col>
              )}
              {!hasPilote && isPilote && (
                <Col>
                  <Button type="primary" onClick={showDefPiloteModal}>
                    DÃ©finir un pilote et une gravitÃ©
                  </Button>
                </Col>
              )}
              {isPilote && (
                <Col>
                  <Popconfirm
                    title="Confirmez-vous la demande de validation de cet Ã©vÃ©nement?"
                    // description=""
                    onConfirm={() => onAskValidation(eventData?.id || 0)}
                    // onCancel={() => console.log("cancel")}
                    okText="Oui, demander"
                    cancelText="Annuler"
                  >
                    <Button
                      type="primary"
                      disabled={
                        isAdmin || eventData?.gravity === 1
                          ? !hasPilote
                          : isAskingValidation ||
                            !hasPilote ||
                            !hasCauseAnalysis ||
                            !eventData?.actions?.length ||
                            eventData?.statut === "DEMANDE_VALIDATION" ||
                            eventData?.statut === "CLOTURE"
                      }
                    >
                      Demander la validation
                    </Button>
                  </Popconfirm>
                </Col>
              )}
              {isAdmin && (
                <Col>
                  <Button
                    type="primary"
                    onClick={showCloseOrRefuseModal}
                    // disabled={!isEventClosable}
                    disabled={!hasPilote}
                  >
                    ClÃ´turer ou refuser
                  </Button>
                </Col>
              )}
              {isAdmin && (
                <Col>
                  <Button
                    type="primary"
                    disabled={eventData?.statut !== "CLOTURE"}
                    onClick={() => onReopen(eventData?.id || 0)}
                  >
                    RÃ©ouvrir
                  </Button>
                </Col>
              )}
              {isAdmin && (
                <Col>
                  <Popconfirm
                    title="Confirmez-vous l'archivage de cet Ã©vÃ©nement?"
                    // description=""
                    onConfirm={() => archiveEvent(eventData?.id || 0)}
                    // onCancel={() => console.log("cancel")}
                    okText="Oui, archiver"
                    cancelText="Annuler"
                  >
                    <Button
                      type="primary"
                      // disabled={eventData?.statut !== "CLOTURE"}
                      disabled={!hasPilote}
                    >
                      Archiver
                    </Button>
                  </Popconfirm>
                </Col>
              )}
              {/* <Col>
      <Button
        className={styles.downloadButton}
        onClick={() => {
          const url = `${config.apiUrl}/events/${id}/export`;
        }}
      >
        TÃ©lÃ©charger en PDF
      </Button>
    </Col> */}
            </Row>
          </Col>
        </Row>
      )}
      <Br height={spacing.sm} />
      {/**
       * Cards Description and DateAndPlace
       */}
      <Row gutter={spacing.m} className={styles.firstRow}>
        <Col span={spacing.s}>
          <CardDescription
            eventData={eventData}
            className={styles.cardsEventDetail}
          />
        </Col>
        <Col span={spacing.xxs} className={styles.colDate}>
          <CardDateAndPlace
            eventData={eventData}
            className={styles.cardsEventDetail}
          />
        </Col>
      </Row>
      {/**
       * Cards Pilote, CauseAnalysis and Actions
       */}
      {pilote && (
        <>
          <Br height={spacing.xl} />
          <Row gutter={spacing.m} className={styles.secondRow}>
            <Col span={spacing.xxs} className={styles.colPilote}>
              <CardPiloteGravity
                eventData={eventData}
                pilote={pilote}
                className={styles.cardsEventDetail}
              />
            </Col>
            <Col span={spacing.s}>
              <CardCauseAnalysis
                eventData={eventData}
                refetchEvent={refetchEvent}
                className={`${styles.cardsEventDetail} ${styles.cardCauseAnalysis}`}
                canAddCauseAnalysis={isPilote}
                hasAnalysis={!!hasCauseAnalysis}
              />
            </Col>
          </Row>
          <Br height={spacing.xl} />
          <Row>
            <Col span={spacing.m} className={styles.colActionPlan}>
              <div className={styles.actionHeader}>
                <h3>Plan d'action</h3>
                <Button
                  type="primary"
                  onClick={navigateToActionNew}
                  disabled={!canCreateAction || isUser}
                >
                  Ajouter une nouvelle action
                </Button>
              </div>
              <Br height={spacing.sm} />
              <div className={styles.cardsEventDetail}>
                <TableActions
                  iAmTheAssignedPilote={iAmTheAssignedPilote}
                  actionsData={eventData?.actions}
                  fetchData={refetchEvent}
                  dontFetchOnMount
                  isLoading={isFetching || isDeletingAction}
                  onDelete={onDeleteAction}
                  isColumnForPageEvent={true}
                />
              </div>
            </Col>
          </Row>
        </>
      )}
      {/**
       * Modal Dispatch Pilote
       */}
      <Modal
        {...modalProps}
        open={isDefPiloteModalOpen}
        onCancel={onHideModalDefinePilote}
        loading={isDispatchingPilote}
        title={<p>Ajouter un pilote et une gravitÃ©</p>}
        footer={
          <>
            <Button
              type="default"
              onClick={onHideModalDefinePilote}
              disabled={isDispatchingPilote}
            >
              Annuler
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              disabled={isDispatchingPilote}
              loading={isDispatchingPilote}
              form={formName}
            >
              Ajouter
            </Button>
          </>
        }
      >
        {!dataReadyForModal || !pilotes?.length || !admins?.length ? (
          <Loading3QuartersOutlined spin />
        ) : (
          <FormDefinePilote
            onSubmit={dispatchPilote}
            pilotes={pilotes}
            admins={admins}
            themes={themesData?.results || []}
          />
        )}
      </Modal>
      {/**
       * Modal Close or Refuse
       */}
      <Modal
        {...modalProps}
        open={isCloseOrRefuseModalOpen}
        onCancel={onHideModalCloseOrRefuse}
        loading={isValidating}
        title={<p>ClÃ´turer ou refuser</p>}
        footer={
          <>
            <Button
              type="default"
              onClick={onHideModalCloseOrRefuse}
              disabled={isValidating}
            >
              Annuler
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              disabled={isValidating}
              loading={isValidating}
              form={formNameEventValidate}
            >
              Soumettre
            </Button>
          </>
        }
      >
        <FormEventValidate onSubmit={validateOrRefuseOnSubmit} />
      </Modal>
    </PageLayout>
  );
};

export default PageEvent;
